import { render, staticRenderFns } from "./BLogin.vue?vue&type=template&id=03167e02&"
import script from "./BLogin.vue?vue&type=script&lang=js&"
export * from "./BLogin.vue?vue&type=script&lang=js&"
import style0 from "./BLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QBtn});
